export default "__VITE_ASSET__lJEjxv15__"